(function () {
    'use strict';

    angular.module('elogbooks.admin.roles', []);
})();
